import React from "react";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

function RejectionResponse({ onSubmit, collectResponse, setCollectResponse }) {
  const { CatelogueLoading } = useSelector((state) => state.catelogueData);
  return (
    <div className="textAlign-center flex column gap-10px">
      <h6 className="flex font-18px margin-0px">Reason for not Approval</h6>

      <div>
        <textarea
          className="border-radius-12"
          rows="10"
          name="response"
          value={collectResponse}
          style={{
            border: "10px solid transparent",
            outline: "2px solid transparent",
            minHeight: "150px",
            backgroundColor: "#fafafa",

            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
          onChange={(e) => setCollectResponse(e.target.value)}
        />
        <p className="flex justify-end">
          <button
            className="button-style pointer white-text font-weight-600 font-16px font-cercular-bold"
            style={{
              padding: "8px 20px",
              backgroundColor: collectResponse === "" ? "#e0e0e0" : "#6f2da8",
            }}
            onClick={onSubmit}
            disabled={collectResponse === ""}
          >
            {CatelogueLoading ? <ClipLoader color="red" size={20} /> : "Submit"}
          </button>
        </p>
      </div>
    </div>
  );
}

export default RejectionResponse;
